<template>
  <div class="pinClass">
    <v-card class="my-5">
      <v-card-text>
          <img :src="imageUrl" height="150px">
          <v-text-field
            label="Game PIN"
            prepend-icon="games"
            v-model="pinCode"
            type="number"
            :error="error"
          ></v-text-field>
          <v-alert error value="true" v-if="error">
            {{errorMessage}}
          </v-alert>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn primary @click.native="login()">
          Start to play
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import VueMarkdown from 'vue-markdown'
  import {mapActions} from 'vuex'
  import {teamLogin} from '../services/teamService'

  import selected from '../geogaming-selected'
  import config from '../geogaming-config'

  const DEFAULT_CONFIG_NAME = 'default'
  const configName = selected.envName
  console.log(' > stage:' + configName)

  const DEFAULT_IMAGE_URL = config[configName] ? config[configName].logo : config[DEFAULT_CONFIG_NAME].logo

  const actions = mapActions([
    'loginTeam',
  ])

  export default {
    name: 'pinCodeLogin',
    components: {
      VueMarkdown,
    },
    data() {
      return {
        pinCode: '',
        error: false,
        errorMessage: '',
      }
    },
    computed: {
      imageUrl: function () {
        return DEFAULT_IMAGE_URL
      },
    },
    methods: {
      ...actions,
      login() {
        this.clearErrorMessage()

        const credentials = {
          pinCode: this.pinCode,
        }
        teamLogin(credentials, this.$store.state.fingerprint)
        .then((loginDetails) => {
          this.loginTeam(loginDetails)
        })
        .then(() => {
          this.$emit('loginSuccess')
          this.$router.push({name: 'Home'})
        })
        .catch((error) => {
          console.error(error)
          if (error.response && error.response.status === 401) {
            this.errorMessage = error.response.data.message
          } else {
            this.errorMessage = 'Sorry we are unable to serve your request :('
          }
          this.error = true
        })
      },
      clearErrorMessage() {
        this.errorMessage = ''
        this.error = false
      }
    },
  }
</script>

<style lang="scss" type="text/scss" scoped>

  @keyframes bgcolor {
    0% {
      background-color: #45a3e5
    }
    30% {
      background-color: #66bf39
    }
    60% {
      background-color: #eb670f
    }
    90% {
      background-color: #f35
    }
    100% {
      background-color: #864cbf
    }
  }

  .pinClass {
    -webkit-animation: bgcolor 20s infinite;
    animation: bgcolor 10s infinite;
    -webkit-animation-direction: alternate;
    animation-direction: alternate;
    height: 100%;
  }

  .card {
    max-width: 500px;
    padding-bottom: 20px;
    padding-left: 20px;

    /deep/ {

      .card__text {
        padding-top: 0;
        padding-bottom: 0;

        .question-wrapper {
          text-align: left;

          p {
            font-size: 18px;
          }
        }

        .input-group--text-field {
          margin: 0 0 18px 0;
        }
      }

      .input-group__details {
        min-height: 2px;
      }

      .card__actions .fa-chevron-left {
        font-size: 1.2rem;
        margin-right: 10px;
      }
    }
  }

  .card {
    margin: auto;
  }

  @media screen and (max-width: 548px) {
    .card {
      margin: 28px;
    }
  }

  .overlay {
    position: relative;
  }

  .overlay:after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .dialog .sign-in-wrapper {
    margin-right: 15px;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0.0;
    }
    100% {
      opacity: 1.0;
    }
  }


</style>




// WEBPACK FOOTER //
// src/components/PinCodeLogin.vue